import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';
import ZdravoMarijaPocetak from './ZdravoMarijaPocetak';
import ZdravoMarijaKraj from './ZdravoMarijaKraj';
import SlavaOcu from './SlavaOcu';
import Amen from './Amen';
import OmojIsuse from './OmojIsuse';
import { getColor } from '../store/boje';

const useStyles = makeStyles((theme) => ({
  opisMolitve: {
    justifyContent: 'space-between',
    // margin: ' auto',
    fontSize: '1.6rem',
    textAlign: 'center',
    lineHeight: '1.2',
    [theme.breakpoints.up('sm')]: {
      color: '#093145',
      fontSize: '2rem',
    },
  },
  gospa: {
    marginTop: '0.5rem',
    margin: ' auto',
    fontSize: '1.6rem',
    color: getColor(2),
    [theme.breakpoints.up('sm')]: {
      color: '#093145',
      fontSize: '2rem',
    },
  },
  rita: {
    marginTop: '0.5rem',
    margin: ' auto',
    fontSize: '1.6rem',
    color: getColor(1),
    [theme.breakpoints.up('sm')]: {
      color: '#093145',
      fontSize: '2rem',
    },
  },
  gertruda: {
    marginTop: '0.5rem',
    margin: ' auto',
    fontSize: '1.6rem',
    color: getColor(0),
    [theme.breakpoints.up('sm')]: {
      color: '#093145',
      fontSize: '2rem',
    },
  },
}));

function ZrnoDeset() {
  const classes = useStyles();
  const { aktivnaZemlja, zrno, aktivnoOtajstvo, trenutnaKrunica } =
    storeKrunica;
  const { krunice } = aktivnaZemlja;

  // console.log('zrno=', zrno, 'trenutnaKrunica=', trenutnaKrunica);

  return (
    <Fragment>
      <div className={classes.opisMolitve}>
        {trenutnaKrunica !== 'gertruda' && <ZdravoMarijaPocetak />}
        <div
          className={
            trenutnaKrunica === 'gospa'
              ? classes.gospa
              : trenutnaKrunica === 'gertruda'
                ? classes.gertruda
                : classes.rita
          }
        >
          {zrno === 16 &&
            trenutnaKrunica === 'rita' &&
            aktivnaZemlja.prvaDeseticaRita}
          {zrno === 16 &&
            trenutnaKrunica === 'gertruda' &&
            krunice.find((k) => k.value === trenutnaKrunica)
              ?.presvetoSrceIsusovo}
          {zrno === 16 &&
            aktivnoOtajstvo === 'otajstvoZalosno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.prvaDeseticaZalosna}
          {zrno === 16 &&
            aktivnoOtajstvo === 'otajstvoSlavno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.prvaDeseticaSlavna}
          {zrno === 16 &&
            aktivnoOtajstvo === 'otajstvoRadosna' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.prvaDeseticaRadosna}
          {zrno === 16 &&
            aktivnoOtajstvo === 'otajstvoSvjetla' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.prvaDeseticaSvjetla}
          {zrno === 27 &&
            trenutnaKrunica === 'rita' &&
            aktivnaZemlja.drugaDeseticaRita}
          {zrno === 27 &&
            trenutnaKrunica === 'gertruda' &&
            krunice.find((k) => k.value === trenutnaKrunica)
              ?.presvetoSrceIsusovo}
          {zrno === 27 &&
            aktivnoOtajstvo === 'otajstvoZalosno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.drugaDeseticaZalosna}
          {zrno === 27 &&
            aktivnoOtajstvo === 'otajstvoSlavno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.drugaDeseticaSlavna}
          {zrno === 27 &&
            aktivnoOtajstvo === 'otajstvoRadosna' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.drugaDeseticaRadosna}
          {zrno === 27 &&
            aktivnoOtajstvo === 'otajstvoSvjetla' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.drugaDeseticaSvjetla}
          {zrno === 38 &&
            trenutnaKrunica === 'rita' &&
            aktivnaZemlja.trecaDeseticaRita}
          {zrno === 38 &&
            trenutnaKrunica === 'gertruda' &&
            krunice.find((k) => k.value === trenutnaKrunica)
              ?.presvetoSrceIsusovo}
          {zrno === 38 &&
            aktivnoOtajstvo === 'otajstvoZalosno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.trecaDeseticaZalosna}
          {zrno === 38 &&
            aktivnoOtajstvo === 'otajstvoSlavno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.trecaDeseticaSlavna}
          {zrno === 38 &&
            aktivnoOtajstvo === 'otajstvoRadosna' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.trecaDeseticaRadosna}
          {zrno === 38 &&
            aktivnoOtajstvo === 'otajstvoSvjetla' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.trecaDeseticaSvjetla}
          {zrno === 49 &&
            trenutnaKrunica === 'rita' &&
            aktivnaZemlja.cetvrtaDeseticaRita}
          {zrno === 49 &&
            trenutnaKrunica === 'gertruda' &&
            krunice.find((k) => k.value === trenutnaKrunica)
              ?.presvetoSrceIsusovo}
          {zrno === 49 &&
            aktivnoOtajstvo === 'otajstvoZalosno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.cetvrtaDeseticaZalosna}
          {zrno === 49 &&
            aktivnoOtajstvo === 'otajstvoSlavno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.cetvrtaDeseticaSlavna}
          {zrno === 49 &&
            aktivnoOtajstvo === 'otajstvoRadosna' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.cetvrtaDeseticaRadosna}
          {zrno === 49 &&
            aktivnoOtajstvo === 'otajstvoSvjetla' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.cetvrtaDeseticaSvjetla}
          {zrno === 60 &&
            trenutnaKrunica === 'rita' &&
            aktivnaZemlja.petaDeseticaRita}
          {zrno === 60 &&
            trenutnaKrunica === 'gertruda' &&
            krunice.find((k) => k.value === trenutnaKrunica)
              ?.presvetoSrceIsusovo}
          {zrno === 60 &&
            aktivnoOtajstvo === 'otajstvoZalosno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.petaDeseticaZalosna}
          {zrno === 60 &&
            aktivnoOtajstvo === 'otajstvoSlavno' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.petaDeseticaSlavna}
          {zrno === 60 &&
            aktivnoOtajstvo === 'otajstvoRadosna' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.petaDeseticaRadosna}
          {zrno === 60 &&
            aktivnoOtajstvo === 'otajstvoSvjetla' &&
            trenutnaKrunica === 'gospa' &&
            aktivnaZemlja.petaDeseticaSvjetla}
        </div>
        {trenutnaKrunica !== 'gertruda' && <ZdravoMarijaKraj />}
        {trenutnaKrunica !== 'gertruda' && <Amen />}
        <SlavaOcu />
        {zrno === 60 && trenutnaKrunica === 'gertruda' && (
          <div>
            <div>{aktivnaZemlja.uImeOcaSina}</div>
            <Amen />
          </div>
        )}
        {trenutnaKrunica !== 'gertruda' && <OmojIsuse />}
      </div>
    </Fragment>
  );
}

export default observer(ZrnoDeset);
